
import React , {useState} from 'react'
import '../styles/Contact.css'
import Navbar from '../components/home/Navbar'
//import Menu from '../components/Menu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope ,faLocation } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin} from '@fortawesome/free-brands-svg-icons';
import Footer from '../components/Footer'
import { IoIosPhonePortrait } from "react-icons/io";
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoLocationSharp } from 'react-icons/io5';
const Contact = () => {
  
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
const myemail = "wifakbargou10@gmail.com"
  const handleSendEmail = () => {
    const mailtoLink = `https://mail.google.com/mail/?view=cm&to=${myemail}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
    window.open(mailtoLink);
  };
  return (
    <div>
      <Navbar/>
      <div className='home-content'>
        
        <div className='contact'>
            <div className='container'>
                <div className='left-bar'>
                    <div>
                    <IoLocationSharp size={40} color="#050a30" /> 
                    <p>Adresse</p> 
                        <a>
                        Avenue Habib Bourguiba, Bargou 6170 Siliana                        </a>
                    </div>
                    <div>
                        <FontAwesomeIcon icon={faEnvelope} size="2x" color='#050a30'/>
                        <p>Email</p> 
                        <a href={`https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(myemail)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`}
                            style={{fontSize:'1rem'}}>
                            wifakbargou10@gmail.com
                        </a>

                    </div>
                    <div>
                        <FontAwesomeIcon icon={faPhone} size="2x" color='#050a30'/>
                        <p>Téléphone</p> 
                        <a href="tel:+21678896560">
                            +216 78 896 560
                        </a>
                    </div>
                    <div>
                    <IoIosPhonePortrait size={40} color="#050a30" />
                    <p>Mobile</p> 
                        <a href="tel:+21698238554">
                            +216 98 238 554
                        </a>
                    </div>
                </div>
                <div id='line' style={{width:'2px', height:'85%',backgroundColor:'#061e6e'}}></div>
                <div className='right-bar'>
                    <h2>Envoyez-nous un message


                    </h2>
                    <p>Pour toute question ou demande, utilisez le formulaire ci-dessous.
                    </p>
                    <input type='email' placeholder='Entrez votre adresse e-mail'/>
                    <input type="text" placeholder='Entrez votre objet'
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}/>

                    <textarea name="" id="" cols="15" rows="10" placeholder='Entrez votre message'
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}></textarea>

                    <button onClick={handleSendEmail}>Envoyer</button>
                </div>
            </div>
        </div>
      </div>
    


    </div>
  )
}

export default Contact